const getNameMap = (options = [], valueField = 'id', labelField = 'name') => {
  const map = new Map();
  options.forEach((option) => {
    if (option?.[valueField] == null) return;
    map.set(String(option[valueField]), option[labelField] || String(option[valueField]));
  });
  return map;
};

const toCleanArray = (value) => {
  if (!Array.isArray(value)) return [];
  return value.filter((item) => item != null && item !== '' && item !== 'all').map(String);
};

export const buildAnalysisFilterTags = ({
  filters,
  customDateRange,
  currency,
  salesUsersData,
  businessUnitsData,
  branchesData,
  sectorsData,
  sourcesData,
  standardsData,
  proposalStagesData,
  taggingOptionsData,
  competitorOptions,
  lostReasonOptions,
  showDepartmentFilter,
  showSalesCreatorFilter,
}) => {
  const tags = [];
  const periodLabels = {
    last_3_days: 'Last 3 Days',
    last_7_days: 'Last 7 Days',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_year: 'Last Year',
    custom: 'Custom Range',
  };

  if (filters?.period && filters.period !== 'this_year') {
    const suffix = filters.period === 'custom' && customDateRange?.startDate && customDateRange?.endDate
      ? ` (${customDateRange.startDate} to ${customDateRange.endDate})`
      : '';
    tags.push({ key: 'period', label: `Period: ${periodLabels[filters.period] || filters.period}${suffix}`, color: 'red', icon: '🗓' });
  }

  if (currency) {
    tags.push({ key: 'currency', label: `Currency: ${String(currency).toUpperCase()}`, color: 'green', icon: '💱' });
  }

  const configs = [
    { key: 'salesCreator', prefix: 'Sales', color: 'purple', icon: '👤', options: salesUsersData, enabled: showSalesCreatorFilter },
    { key: 'department', prefix: 'Dept', color: 'teal', icon: '🏢', options: businessUnitsData, enabled: showDepartmentFilter },
    { key: 'branchId', prefix: 'Branch', color: 'green', icon: '📍', options: branchesData, enabled: true, single: true },
    { key: 'taggingIds', prefix: 'Tagging', color: 'orange', icon: '🏷', options: taggingOptionsData, enabled: true },
    { key: 'sector', prefix: 'Sector', color: 'cyan', icon: '🏭', options: sectorsData, enabled: true },
    { key: 'leadSource', prefix: 'Source', color: 'orange', icon: '📣', options: sourcesData, enabled: true },
    { key: 'standard', prefix: 'Standard', color: 'blue', icon: '📘', options: standardsData, enabled: true },
    { key: 'proposalStage', prefix: 'Stage', color: 'purple', icon: '📊', options: proposalStagesData, enabled: true },
    { key: 'competitor', prefix: 'Competitor', color: 'orange', icon: '⚔', options: competitorOptions, enabled: true },
    { key: 'lostReason', prefix: 'Lost Reason', color: 'red', icon: '📉', options: lostReasonOptions, enabled: true },
  ];

  configs.forEach(({ key, prefix, color, icon, options, enabled, single }) => {
    if (!enabled) return;
    const values = single ? toCleanArray([filters?.[key]]) : toCleanArray(filters?.[key]);
    if (values.length === 0) return;
    const labelMap = getNameMap(options);
    const names = values.map((value) => {
      const key = String(value);
      const mapped = labelMap.get(key);
      if (mapped) return mapped;
      // fallback: try to find option by several common id/value fields
      if (Array.isArray(options) && options.length > 0) {
        const found = options.find((opt) => {
          if (!opt || typeof opt !== 'object') return false;
          const candidates = [opt.id, opt.value, opt.branch_id, opt.name, opt.label];
          return candidates.some((c) => c != null && String(c) === key);
        });
        if (found) return found.name || found.label || String(value);
      }
      return String(value);
    }).join(', ');
    tags.push({ key, label: `${prefix}: ${names}`, color, icon });
  });

  if (filters?.proposalApprovalStatus && filters.proposalApprovalStatus !== 'all') {
    tags.push({ key: 'proposalApprovalStatus', label: `Approval: ${filters.proposalApprovalStatus}`, color: 'green', icon: '✅' });
  }

  return tags;
};